<template>
    <div class="p-4">
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormEncuestaResuelta" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row" v-for="(item,index) in Preguntas.config_encuesta_pregunta" :key="index">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label for="">{{(index+1)+'.- '+item.Pregunta }}</label>
                                                <div v-if="item.TipoPregunta=='1' || item.TipoPregunta=='2'">
                                                    <div class="row" v-if="item.TipoPregunta=='1'">
                                                        <div v-for="(itemDefault,indexDefault) in OpcionesDefault" :key="indexDefault" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <div v-if="item.TipoRespuesta=='UNICO'" class="form-check">
                                                                <input type="radio" class="form-check-input" v-model="item.Respuesta" :id="'flexRadioDefault_'+index+'_'+indexDefault" :value="itemDefault">
                                                                <label class="form-check-label" :for="'flexRadioDefault_'+index+'_'+indexDefault">
                                                                    {{ itemDefault.Nombre }}
                                                                </label>
                                                            </div>
                                                            <div v-if="item.TipoRespuesta=='MULTIPLE'" class="form-check">
                                                                <input type="checkbox" class="form-check-input" v-model="item.RespuestaMultiple" :id="'Check_'+index+'_'+indexDefault" :value="itemDefault">
                                                                <label :for="'Check_'+index+'_'+indexDefault">{{ itemDefault.Nombre }}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                                    <div class="row" v-if="item.TipoPregunta=='2'">
                                                        <div v-for="(itemEncuesta,indexEncuesta) in OpcionesEncuesta" :key="indexEncuesta" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                            <div v-if="item.TipoRespuesta=='UNICO'" class="form-check">
                                                                <input type="radio" class="form-check-input" v-model="item.Respuesta" :id="'flexRadioDefault_'+index+'_'+indexEncuesta" :value="itemEncuesta">
                                                                <label class="form-check-label" :for="'flexRadioDefault_'+index+'_'+indexEncuesta">
                                                                    {{ itemEncuesta.Nombre }}
                                                                </label>
                                                            </div>
                                                            <div v-if="item.TipoRespuesta=='MULTIPLE'" class="form-check">
                                                                <input type="checkbox" class="form-check-input" v-model="item.RespuestaMultiple" :id="'Check_'+index+'_'+indexEncuesta" :value="itemEncuesta">
                                                                <label :for="'Check_'+index+'_'+indexEncuesta">{{ itemEncuesta.Nombre }}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                <div class="row" v-if="item.TipoPregunta==3">
                                                    <div v-for="(itemRespuesta,indexRespuesta) in item.config_encuesta_respuesta" :key="indexRespuesta" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                        <div v-if="item.TipoRespuesta=='UNICO'" class="form-check">
                                                            <div class="form-check">
                                                                <input type="radio" class="form-check-input" v-model="item.Respuesta" :id="'flexRadioDefault_'+index+'_'+indexRespuesta" :value="itemRespuesta">
                                                                <label class="form-check-label" :for="'flexRadioDefault_'+index+'_'+indexRespuesta">
                                                                    {{ itemRespuesta.Respuesta }}
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div v-if="item.TipoRespuesta=='MULTIPLE'" class="form-check">
                                                            <input type="checkbox" class="form-check-input" v-model="item.RespuestaMultiple" :id="'Check_'+index+'_'+indexRespuesta" :value="itemRespuesta">
                                                            <label :for="'Check_'+index+'_'+indexRespuesta">{{ itemRespuesta.Respuesta }}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                <div v-if="item.TipoPregunta==4" class="col-lg-12">
                                                    <div class="form-check-inline" v-for="(itemPregunta,indexPregunta) in Valoracion" :key="indexPregunta">
                                                        <input type="radio" class="form-check-input d-none valorseleccionado" :id="'Pregunta_'+index+'_'+indexPregunta" v-model="item.Respuesta" :value="itemPregunta">
                                                        <label class="form-check-label" :for="'Pregunta_'+index+'_'+indexPregunta">{{ itemPregunta }}</label>
                                                    </div>
                                                </div>
                                            
                                                <div v-if="item.TipoPregunta=='5'" class="col-lg-12">
                                                    <div class="row">
                                                        <div class="col-lg-1">
                                                            <div class="form-check">
                                                                <input type="radio" class="form-check-input" v-model="item.Respuesta" :id="'Si_'+index" value="SI">
                                                                <label :for="'Si_'+index" class="form-check-label">{{ Idioma=='ESP' ? 'SI' : 'YES' }}</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-1">
                                                            <div class="form-check">
                                                                <input type="radio" class="form-check-input" v-model="item.Respuesta" :id="'No_'+index" value="NO">
                                                                <label :for="'No_'+index" class="form-check-label">NO</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                <div v-if="item.TipoPregunta=='6'" class="col-lg-12">
                                                    <textarea v-model="item.Respuesta" cols="30" rows="3" class="form-control"></textarea>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <CBtnSave :poBtnSave="oBtnSave" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
    </div>
</template>

<script>
const EmitEjecuta = 'seccionEncuestaResuelta';
export default {
    name: 'FormEncuestaResuelta',
    props: ['Id','TipoEncuesta','Idioma','IdEmpresa','IdSucursal','FechaEnvio','IdResponde','Token'],
    components:{},
    data() {
        return {
            ConfigList:{
                Title:'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: this.TipoEncuesta=='COORDINADOR' ? 'Encuesta de Coordinadores' : 'Encuesta de Parejas',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: '',
                EmitSeccion: EmitEjecuta,
            },
            objEncuestaResuelta:{
                IdEncuestaResuelta:0,
                IdConfigEncuesta:0,
                IdBodaCopia:0,
                IdCliente:0,
                IdUserHotel:0,
                IdVendedora:0,
                FechaEnvio:'',
                FechaContesto:'',
                TipoEncuesta:'',
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
            Preguntas:{},
            OpcionesDefault:[],
            OpcionesEncuesta:[],
            Respuestas:[],
            Valoracion:[1,2,3,4,5,6,7,8,9,10]
        }
    },
    methods: {
        async Guardar(){
            this.oBtnSave.DisableBtn=true;
            let BndError=false;
            let Mensaje="";
            let index=0;
            this.Preguntas.config_encuesta_pregunta.every((element)=>{
                if (element.TipoRespuesta=="MULTIPLE") {
                    if (element.RespuestaMultiple.length==0) {
                        Mensaje="Debe seleccionar al menos una respuesta de la pregunta "+(index+1);
                        BndError=true;
                        return false;
                    }
                }
                else{
                    if (typeof element.Respuesta=='undefined' || element.Respuesta=='') {
                        Mensaje="Debe seleccionar una respuesta de la pregunta "+(index+1);
                        BndError=true;
                        return false;
                    }
                }
                index++;
                return true;
            });
            if (BndError) {
                this.$toast.warning(Mensaje);
                this.oBtnSave.DisableBtn=false;
                return false;
            }
            let formData=new FormData();
            formData.set('IdConfigEncuesta',this.Preguntas.IdConfigEncuesta);
            formData.set('TipoEncuesta',this.Preguntas.TipoEncuesta);
            formData.set('IdResponde',this.IdResponde);
            formData.set('IdEmpresa',this.IdEmpresa);
            formData.set('IdSucursal',this.IdSucursal);
            formData.set('MasterNum',this.Token);
            formData.set('Preguntas',JSON.stringify(this.Preguntas.config_encuesta_pregunta));
            let date=this.FechaEnvio.getFullYear();
            let month=this.FechaEnvio.getMonth()+1;
            let day=this.FechaEnvio.getDate();
            let Fecha=date+'-'+month+'-'+day;
            formData.set('FechaEnvio',Fecha);
            this.$http.post("encuestaResuelta",formData)
            .then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.$router.push({name:'encuestaConfirmacion'});
        },
        EjecutaConError(err){
            
        },
        Recuperar(){

        },
        Regresar(){
            this.$router.push({name:"responderencuesta"});
        },
        ListarPreguntas(){
            this.ConfigLoad.ShowLoader = true;
            this.$http.get('configEncuestasPreguntasResolver',{
                params:{
                    TipoEncuesta:this.TipoEncuesta,
                    Idioma:this.Idioma,
                    IdEmpresa:this.IdEmpresa,
                    IdSucursal:this.IdSucursal,
                    Anio:this.FechaEnvio.getFullYear()
                }
            }).then((res)=>{
                res.data.data[0].config_encuesta_pregunta.forEach((element)=>{
                    // element.Respuesta='';
                    element.RespuestaMultiple=[];
                });
                this.Preguntas=res.data.data[0];
                this.Preguntas.config_encuesta_opcion_predeterminada.forEach((element)=>{
                    if (element.Tipo=='opcion') {
                        this.OpcionesDefault.push(element);
                    }
                });
                this.Preguntas.config_encuesta_opcion_predeterminada.forEach((element)=>{
                    if (element.Tipo=='encuesta') {
                        this.OpcionesEncuesta.push(element);
                    }
                });
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            })
        },
        // SeleccionOpcion(item,index){
        //     if (item.TipoPregunta==1) {
        //         item.RespuestaSeleciconada=this.OpcionesDefault[index];
        //     }
        //     else if(item.TipoPregunta==2){
        //         item.RespuestaSeleciconada=this.OpcionesEncuesta[index];
        //     }
        //     else{
        //         item.RespuestaSeleciconada=item.config_encuesta_respuesta[index];
        //     }
        // }
    },
    created() {
        // this.Id='';
        this.oBtnSave.Toast = 0;
        // this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        if(this.Id!='') 
        {
            this.objEncuestaResuelta.IdEncuestaResuelta = this.Id;
            this.Recuperar();
        }
        else
		{
            this.ListarPreguntas();
		}
        this.bus.$on('Save_'+this.Emit,()=>
        {
            this.Guardar();
        });
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>